<template>
	<div style="width: 90%;margin: 0 auto;position: relative;">
		<h2>Medibot 智能客服系统</h2>
		<el-tabs type="border-card" @tab-click="tabClick">
			<el-tab-pane label="项目管理">
				<div class="project_div" v-if="isShowList">
					<div class="add_div">
						<el-button type="primary" style="width: 6.25rem;height: 2.8125rem;" 
						@click="addAction" v-if="roleType === 0">新建项目</el-button>
					</div>
					<el-card class="box-card" shadow="hover" v-for="(item, index) in projectList">
						<project-cell :proDetail="item" :key="index" @delAction="delProjectAction" 
						@editAction="editProjectAction" :role="roleType"
						@toPage="toPageAction"></project-cell>
					</el-card>
				</div>
				<div class="project_div" v-else>
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="!isShowList" style="margin-top: 0.625rem;margin-bottom: 2.5rem;">
						<el-breadcrumb-item v-for="(item, index) in crumbList" :key="index">{{item}}</el-breadcrumb-item>
					</el-breadcrumb>
					<add-project :projInfo="selectProject" @addPage="addPageAction" @saveProject="saveProjectAction" 
					@addBack="addBackAction" v-if="isAddProject"></add-project>
					<page-list v-if="iShowTab === 1" @pageBack="pageListBack" @listaddpage="addPageAction()" 
					:projectInfo="selectProject" @listeditpage="editPageAction"></page-list>
					<add-page @pageBack="pageBackAction" v-else-if="iShowTab === 2" :projectItem="selectProject"
					:selectPage="editPageInfo"></add-page>
				</div>

			</el-tab-pane>
			<el-tab-pane v-if="roleType === 0" label="用户管理">
				<div class="user_div" v-if="isShowUserList">
					<all-user :userList="userList" @bindAddUser="addUserAction" @editUser="editUserAction" @deleteUser="deleteUserAction"
					:pageInfo="userpage" @pagePre="getUserList" @pageNext="getUserList" @stateAction="getSearchUser"
					@serchAction="getSearchUser"></all-user>
				</div>
				<div class="user_div" v-else>
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="!isShowUserList" style="margin-top: 0.625rem;margin-bottom: 2.5rem;">
						<el-breadcrumb-item v-for="(item, index) in userCrumbList" :key="index">{{item}}</el-breadcrumb-item>
					</el-breadcrumb>
					<add-user @userBack="userBackAction" @addUser="saveUserAction" v-if="isAddUser"></add-user>
					<edit-user @editBack="editBackAction" @editSave="editSaveAction" :userInfo="selectUser" v-else></edit-user>
				</div>
			</el-tab-pane>
		</el-tabs>
		
		<el-button type="text" @click="logout" size="medium" style="position: absolute;right: 5%;top: 3.7rem;color: gray;">退出</el-button>
		
	</div>
</template>

<script>
	import projectCell from '../components/projectcell.vue'
	import addProject from '../components/addproject.vue'
	import allUser from '../components/alluser.vue'
	import addUser from '../components/adduser.vue'
	import editUser from '../components/edituser.vue'
	import addPage from '../components/addpage.vue'
	import pageList from '../components/pagelist.vue'

	export default {
		name: 'home',

		components: {
			projectCell,
			addProject,
			allUser,
			addUser,
			editUser,
			addPage,
			pageList
		},

		data() {
			return {
				projectList: [],
				isShowList: true,
				isAddProject: false,
				iShowTab:0, //0- 1 2
				crumbList: [],
				selectProject:null,

				userCrumbList: [],
				isShowUserList: false,
				userList: [],
				isAddUser: true,
				selectUser: null,
				roleType: 0,
				editPageInfo:null,
				userpage: {
					current:0,
					total:0
				},
			}
		},

		mounted() {
			console.log('home mounted')
			this.currentInfoRequest()
			this.projectRequest()
		},

		methods: {
			async projectRequest() {
				var api = "/projectchat/project/select";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current: 0,
						size: 99
					},
				});
				console.log("home projectRequest response = ", response);
				if (response.data.projectVoList !== null) {
					this.projectList = response.data.projectVoList
				}
			},
			
			async currentInfoRequest() {
				var api = "/projectchat/user/selectCurrentUser";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
				});
				console.log("home currentInfoRequest response = ", response);
				this.roleType = response.data.userType
			},

			async allUserRequest() {
				var api = "/projectchat/user/select";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current: 0,
						size: 10,
						status: '',
						name: ''
					},
				});
				console.log("home userRequest response = ", response);
				if (response.data !== null) {
					this.userList = response.data.list
					for (var i = 0; i < this.userList.length; i++) {
						var obj = this.userList[i]
						if (obj.status === 1) {
							obj.status = '可用'
						} else {
							obj.status = '停用'
						}
					}
					
					this.userpage.current = response.data.current
					this.userpage.total = response.data.total
				} else {
					this.userList = []
				}
			},
			
			async getUserList(pnum) {
				console.log('home getUserList pnum = ', pnum)
				var api = "/projectchat/user/select";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current: pnum,
						size: 10,
						status: '',
						name: ''
					},
				});
				console.log("home getUserList response = ", response);
				if (response.data !== null) {
					this.userList = response.data.list
					for (var i = 0; i < this.userList.length; i++) {
						var obj = this.userList[i]
						if (obj.status === 1) {
							obj.status = '可用'
						} else {
							obj.status = '停用'
						}
					}
					
					this.userpage.current = response.data.current
					this.userpage.total = response.data.total
				} else {
					this.userList = []
				}
			},
			
			async getSearchUser(state, content) {
				console.log('home getSearchUser state = ', state)
				console.log('home getSearchUser content = ', content)
				var api = "/projectchat/user/select";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						current: 0,
						size: 10,
						status: state,
						name: content
					},
				});
				console.log("home getSearchUser response = ", response);
				if (response.data !== null) {
					this.userList = response.data.list
					for (var i = 0; i < this.userList.length; i++) {
						var obj = this.userList[i]
						if (obj.status === 1) {
							obj.status = '可用'
						} else {
							obj.status = '停用'
						}
					}
					
					this.userpage.current = response.data.current
					this.userpage.total = response.data.total
				} else {
					this.userList = []
				}
			},

			addAction() {
				console.log('home addAction')
				this.crumbList.push('项目管理')
				this.crumbList.push('新建项目')
				this.isShowList = false
				this.isAddProject = true
				
				this.selectProject = null
			},

			tabClick(tab, event) {
				console.log('home tabClick tabindex = ', tab.index)
				if (tab.index === 0) {
					//项目管理
					this.isShowList = true
					this.projectRequest()

				} else if (tab.index === '1') {
					//用户管理
					this.isShowUserList = true
					this.allUserRequest()
				}
			},

			addUserAction() {
				console.log('home addUserAction')
				this.userCrumbList.push('用户管理')
				this.userCrumbList.push('添加新员工')
				this.isShowUserList = false
				this.isAddUser = true
			},

			editUserAction(user) {
				console.log('home editUserAction user = ', user)
				this.userCrumbList.push('首页')
				this.userCrumbList.push('编辑员工信息')
				this.isShowUserList = false
				this.isAddUser = false

				this.selectUser = user
			},

			addPageAction() {
				console.log('home addPageAction')
				this.isShowList = false
				this.isAddProject = false
				this.iShowTab = 2
				this.crumbList.push('添加落地页信息')
				this.editPageInfo = null
			},
			
			editPageAction(obj) {
				console.log('home editPageAction obj = ', obj)
				this.getPageRequest(obj.pageId)
			},
			
			async getPageRequest(pageid) {
				console.log('home getPageRequest')
				var api = "/projectchat/projectMessage/selectByPageId";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						pageId: pageid,
					},
				});
				console.log("home getPageRequest response = ", response);
				if (response.resultCode === '10000') {
					console.log("home getPageRequest data = ", response.data);
					this.editPageInfo = response.data
					this.isShowList = false
					this.isAddProject = false
					this.iShowTab = 2
					this.crumbList.push('编辑落地页信息')
				} else {
					this.$message.error(response.desc)
				}
			},

			delProjectAction(item) {
				console.log('home delProjectAction item = ', item)
				let tip = '确认删除项目：' + item.name + '?'
				this.$confirm(tip, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delProjectRequest(item)
				}).catch(() => {

				});
			},

			async delProjectRequest(item) {
				console.log('home delProjectRequest')
				var api = "/projectchat/project/del";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: item.id,
					},
				});
				console.log("home delProjectRequest response = ", response);
				if (response.resultCode === '10000') {
					this.projectRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

			editProjectAction(item) {
				console.log('home editProjectAction item = ', item)
				if (this.crumbList.length === 0) {
					this.crumbList.push('项目管理')
					this.crumbList.push('编辑管理')
				} else {
					this.crumbList.pop()
					this.crumbList.push('编辑项目')
				}

				this.isShowList = false
				this.isAddProject = true
				this.iShowTab = 0
				
				this.selectProject = item
				console.log('home editProjectAction selectProject = ', this.selectProject)
			},
			
			toPageAction(item) {
				console.log('home toPageAction item = ', item)
				this.isShowList = false
				this.isAddProject = false
				this.iShowTab = 1
				
				this.selectProject = item
			},

			addBackAction() {
				console.log('home addBackAction')
				this.crumbList = []
				this.isShowList = true
				this.isAddProject = false
			},

			pageBackAction() {
				console.log('home pageBackAction')
				if (this.crumbList.length > 2) {
					this.crumbList.pop()
				}
				this.isShowList = false
				this.isAddProject = false
				this.iShowTab = 1
			},
			
			pageListBack() {
				console.log('home pageListBack')
				this.isShowList = true
				this.isAddProject = false
				this.iShowTab = 2
			},

			userBackAction() {
				console.log('home userBackAction')
				this.userCrumbList = []
				this.isShowUserList = true
				this.isAddUser = false
			},

			editBackAction() {
				console.log('home editBackAction')
				this.userCrumbList = []
				this.isShowUserList = true
				this.isAddUser = false
			},

			async saveUserAction(form) {
				console.log('home saveUserAction')
				var api = "/projectchat/user/addOrEdit";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						realName: form.account,
						loginName: form.name,
						password: form.password,
						status: '1',
						projectId: ''
					},
				});

				console.log("home saveUserAction response = ", response);
				if (response.resultCode === '10000') {
					this.userBackAction()
					this.allUserRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

			async editSaveAction(form, password) {
				var api = "/projectchat/user/addOrEdit";

				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: this.selectUser.id,
						realName: form.account,
						loginName: form.name,
						password: password,
						status: form.status,
						projectId: ''
					},
				});

				console.log("home editSaveAction response = ", response);
				if (response.resultCode === '10000') {
					this.editBackAction()
					this.allUserRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

			deleteUserAction(item) {
				console.log('home deleteUserAction item = ', item)
				let tip = '确认删除用户' + item.loginName + '?'
				this.$confirm(tip, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delUserRequest(item)
				}).catch(() => {

				});
			},

			async delUserRequest(item) {
				console.log('home delUserRequest id = ', item.id)
				var api = "/projectchat/user/del";

				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: item.id
					},
				});

				console.log("home delUserRequest response = ", response);
				if (response.resultCode === '10000') {
					this.allUserRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

			saveProjectAction(edit, item) {
				console.log('home saveProjectAction item = ', item)
				if (edit) {
					this.editProjRequest(item)
				} else {
					this.addProjRequest(item)
				}
				
			},
			
			async addProjRequest(item) {
				console.log('home addProjRequest item = ', item)
				var api = "/projectchat/project/addOrEdit";
				
				var cityId = ''
				 if(typeof(item.cityid) == "number") {
					cityId = item.cityid
				 } else {
					cityId = item.cityid.id
				 }
				 
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						name: item.name,
						describe: item.desc,
						userId: item.leaderid,
						webUrl: item.address,
						provinceId: item.provinceid,
						cityId: cityId
					},
				});
				console.log("home saveProjectAction response = ", response);
				if (response.resultCode === '10000') {
					this.addBackAction()
					this.projectRequest()
				} else {
					this.$message.error(response.desc)
				}
			},
			
			async editProjRequest(item) {
				console.log('home editProjRequest item = ', item)
				var api = "/projectchat/project/addOrEdit";
				
				var cityId = ''
				 if(typeof(item.cityid) == "number") {
					cityId = item.cityid
				 } else {
					cityId = item.cityid.id
				 }
				 
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id:item.id,
						name: item.name,
						describe: item.desc,
						userId: item.leaderid,
						webUrl: item.address,
						provinceId: item.provinceid,
						cityId: cityId
					},
				});
				console.log("home editProjRequest response = ", response);
				if (response.resultCode === '10000') {
					this.addBackAction()
					this.projectRequest()
				} else {
					this.$message.error(response.desc)
				}
			},
			
			logout() {
				this.$router.replace({
					path: '/'
				})
			}
		}

	}
</script>

<style>
	.project_div {
		width: 100%;
		height: 53.125rem;
		overflow: scroll;
		/* background-color: aqua; */
	}

	.add_div {
		width: 80%;
		height: 3.75rem;
		/* background-color: orchid; */
		display: flex;
		justify-content: flex-end;
		margin: 0 auto;
		margin-bottom: 1.25rem;
		padding: 0.625rem;
	}

	.box-card {
		width: 80%;
		height: 9.375rem;
		margin: 0 auto;
		margin-bottom: 1.25rem;
	}

	.user_div {
		width: 100%;
		height: 53.125rem;
		/* background-color: greenyellow; */
	}
</style>
